<script setup lang="ts">
import { Loading as VarLoading, type LoadingProps } from '@varlet/ui';

// eslint-disable-next-line vue/define-props-destructuring
const props = defineProps<LoadingProps>();
</script>

<template>
  <VarLoading v-bind="props">
    <slot />
  </VarLoading>
</template>
